$(document).ready(function () {
  // setting the initial values 
  $(".fan-count").text($(".fan-range").val());
  $("[data-cost]").each(function () {
    $(this).text(Math.floor($(this).data("cost")));
  });

  //fan_count : is number of fans 
  //dataVal : cost taken from the customizer as a data attribute 
  //calculatedCost : rounded value of the cost after multiplication with number of fans 
  
  $(".fan-range").on("input", function () {
    let fan_count = parseInt($(".fan-range").val(), 10);
    //changing the fan count text 
    $(".fan-count").text($(".fan-range").val());

    //looping through the data atribute and changing the inner text deppending on the caculated output
    $("[data-cost]").each(function () {
      let dataVal = parseFloat($(this).data("cost"), 10);
      let claculatedCost = Math.round(dataVal * fan_count);
      $(this).text(claculatedCost);
    });
  });

   if ($(window).width() < 759) {
    $('.average').find('br').remove();
  }
});

 